<template lang="pug">
include /../../s-pug/mixin-icon

//- ------------------------------------------------------------------------

mixin profileEditPanelGroup({first, last} = {})
   div(class=first ? '_pb4' : '_py4' class=last ? '' : '_borderBottom _borderColor-grey-050 _border-width3')&attributes(attributes): block

mixin profileEditPanelGroupHeading({inputLabelConnected} = {})
   ._fs-3._c-grey-900._mb1-5(style="font-weight: 700" class=inputLabelConnected ? 'InputLabel-value' : '_mb075')&attributes(attributes): block

//- ------------------------------------------------------------------------

div
   .Underlay._fixed._alpha-80._radius._cursor-default
   form.EditSlideout(@submit.prevent="$emit('done', {isNew, type, itemIndex, item, items})" novalidate="true" v-bind:class="{'is-fullscreen': isFullscreen}")
      //- Heading
      ._px075._py075._flex._flex-alignItemsCenter._boxShadow._z50
         ._flex-1(v-if="type === 'qaPrimary'")
            ._c-grey-700._fs-3._bold {{ getAttrPropByAttrKey({attrSrc: attrs.qaPrimary, attrKey: item.attrKey}) }}
         ._flex-1(v-else)
            ._c-grey-800._fs-3._bold(v-if="isNew") Add {{type}}
            ._c-grey-800._fs-3._bold(v-else) Edit {{type}}
            ._c-grey-400._fs-1._mt025._bold(v-if="type === 'opening' && item.heading") {{item.heading}}
         ._flex._flex-alignItemsCenter
            button.Btn.Btn--white._px1._mr05(style="height: 40px; font-weight: 400" type="button" @click="fullscreenEnter()" v-if="!isFullscreen")
               | Fullscreen
            button.Btn.Btn--white._px1._mr05(style="height: 40px; font-weight: 400" type="button" @click="fullscreenExit()" v-if="isFullscreen")
               | Exit fullscreen
            button.Btn.Btn--white._p025(style="width: 40px; height: 40px" type="button" @click="$emit('cancel', {type})")
               +icon({grow: true, name: "icon-x"})._c-grey-800
      //- Body
      ._overflowScrollY._customScrollBars._flex-1(ref="profileEditPanelScrollContainer")
         ._px075._py1._mx-auto(style="max-width: 940px")
            //- ------------------------------------------------------------------------
            //- Type : Overview
            //- ------------------------------------------------------------------------
            ._mb2(v-if="type === 'overview'")
               ._mb2
                  //- attr : overview
                  +profileEditPanelGroup({first: true})
                     label.InputLabel--connected
                        textarea#js-focusTarget.Input.Textarea._fs-1._lineHeight--1dot4._textarea-resizeNone(v-model=`items.summary` style="min-height: 140px")
                        +profileEditPanelGroupHeading({inputLabelConnected: true}): | Team summary
                  //- attr : remoteDegree
                  +profileEditPanelGroup()
                     +profileEditPanelGroupHeading(): | Percentage of team that works remote
                     div(v-for="(option, index) in attrs.remoteDegree" v-bind:key="option.optionKey")
                        label._cursor-pointer._flex._flex-alignItemsCenter._px05._py05._radius._bg-grey-050._mb05
                           input.Radio._mr1(type="radio" v-bind:value="option.optionKey" v-model="items.remoteDegree.optionKey") 
                           div 
                              ._mb025 {{option.label}}
                              ._fs-05._c-grey-500 {{option.labelDescription}}
                  //- attr : teamSize
                  +profileEditPanelGroup()
                     +profileEditPanelGroupHeading(): | Team size
                     ._flex._mb05
                        label.InputLabel--connected
                           input#js-focusTarget.Input._wUnset._lineHeight--1dot4._fs-4(v-model=`items.teamSize.exactOrMin` type="number" min="1" style="max-width: 120px")
                           .InputLabel-value._w100(v-if=`items.teamSize.useRange`) From
                        div(v-if=`items.teamSize.useRange`)
                           ._flex._flex-alignItemsCenter(v-if=`items.teamSize.useRange`)
                              label.InputLabel--connected
                                 input.Input._wUnset._lineHeight--1dot4._fs-4(v-model=`items.teamSize.maybeMax` type="number" min="1" ref="jsFocusTargetOnChangeToRangeTrue" style="max-width: 120px")
                                 .InputLabel-value._w100 To
                     label.InputLabel--connected._flexInline._flex-alignItemsCenter
                        SlideToggle(v-model=`items.teamSize.useRange` :customChangeHandler="maybeFocusRangeMaxOnToggle")
                        ._ml05._noSelect Use a range?
                  //- TODO: These should likely be handled at the company level... does there need to be a team-lvel `website`?
                  //- attr : companySize
                  //- attr : website
            //- ------------------------------------------------------------------------
            //- Type : Q&A Primary
            //- ------------------------------------------------------------------------
            ._mb2(v-if="type === 'qaPrimary'")
               ._mb1-5
                  p._italic._c-grey-800._highlight._inlineBlock Q: {{ getAttrPropByAttrKey({attrSrc: attrs.qaPrimary, attrKey: item.attrKey, prop: 'questionPrimary2ndPerson'}) }}
               .InputLabel-value Answer
               ._mb1-5
                  vSelect._fs-3(v-model="item.optionKey" placeholder="Select answer" :options="getAttrPropByAttrKey({attrSrc: attrs.qaPrimary, attrKey: item.attrKey, prop: 'options'})" :clearable="false" :reduce="i => i.optionKey" maxHeight="268px")
                     template(slot="option" slot-scope="option")
                        ._truncate
                           ._truncate._fs-1 {{option.label}}
                           ._fs-05._mt025(v-if="option.blurb") {{option.blurb}}
                  ._mt1(v-if="item.optionKey === 'other'")
                     label.InputLabel--connected._mb1
                        .InputLabel-value Value for "other"
                        input.Input._fs-3(type="text" placeholder="" v-model="item.valueForOther")
               .InputLabel-value._mb05 Description
               .Profile-qaItem._relative
                  EditorTipTap(v-model="item.description" :allowedActions="['bold', 'italic', 'link', 'bullet_list', 'ordered_list', 'image', 'video']")
            //- ------------------------------------------------------------------------
            //- Type : benefit
            //- ------------------------------------------------------------------------
            ._mb2(v-if="type === 'benefit'")
               .InputLabel-value Benefit
               ._mb1-5
                  vSelect._fs-3(v-model="item.optionKey" placeholder="Select benefit" :options="benefitsNotSet" :getOptionLabel="option => getAttrPropByOptionKey({attrSrc: attrs.benefits, optionKey: typeof option === 'string' ? option : option.optionKey})" :clearable="false" :searchable="true" :reduce="i => i.optionKey" maxHeight="268px")
                     template(slot="option" slot-scope="option")
                        ._truncate._py05
                           ._truncate._fs-1 {{option.label}}
                           ._fs-05._mt025(v-if="option.blurb") {{option.blurb}}
                  ._mt3(v-if="item.optionKey === 'other'")
                     label.InputLabel--connected._mb1
                        .InputLabel-value Other benefit label
                        input.Input._fs-3(type="text" placeholder="" v-model="item.valueForOther")
               label.InputLabel--connected._mb1
                  .InputLabel-value Description
                  input.Input._fs-1._py05(type="text" placeholder="Benefit details/info (optional)" v-model="item.description")
            //- ------------------------------------------------------------------------
            //- Type : opening
            //- ------------------------------------------------------------------------
            ._mb2(v-if="type === 'opening'")
               +profileEditPanelGroup({first: true})
                  +profileEditPanelGroupHeading(): | Heading
                  label.InputLabel--connected
                     input.Input._fs-3(type="text" v-model="item.heading")
               +profileEditPanelGroup()
                  +profileEditPanelGroupHeading(): | Salary info
                  div
                     label._cursor-pointer._flex._flex-alignItemsCenter._px05._py05._radius._bg-grey-050._mb05
                        input.Radio._mr1(type="radio" value="include" v-model="item.salaryInfo.key")
                        div Include
                     label._cursor-pointer._flex._flex-alignItemsCenter._px05._py05._radius._bg-grey-050._mb05
                        input.Radio._mr1(type="radio" value="doNotInclude" v-model="item.salaryInfo.key")
                        div Do not include
                  ._mt2(v-if="item.salaryInfo.key === 'include'")
                     label.InputLabel--connected._flexInline._flex-alignItemsCenter._mb1-5
                        SlideToggle(v-model="item.salaryInfo.useRange")
                        ._ml05._noSelect Use a range?
                     ._flex._mb05._flex-justifyContentFlexStart
                        label.InputLabel--connected._flexDirection-column._mr1
                           //- input.Input._w100._lineHeight--1dot4._fs-4(v-model="item.salaryInfo.currency" type="text" style="max-width: 100px")
                           select(style="width: 100px; height: 47px" v-model="item.salaryInfo.currency")._border._borderColor-grey-200._radius._px1
                              option(v-for="(value, key) in currencies" :key="key" :value="key") {{key}}
                           .InputLabel-value Currency
                        label.InputLabel--connected._flexDirection-column._mr1
                           input.Input._lineHeight--1dot4._fs-4(v-model="item.salaryInfo.exactOrMin" type="number" min="1" style="max-width: 200px")
                           .InputLabel-value(v-if="item.salaryInfo.useRange") From
                           .InputLabel-value(v-else) Amount
                        label._flex-alignItemsCenter(v-if="item.salaryInfo.useRange")
                           label.InputLabel--connected._flexDirection-column._mr1
                              input.Input._lineHeight--1dot4._fs-4(v-model="item.salaryInfo.maybeMax" type="number" min="1" style="max-width: 200px")
                              .InputLabel-value To
                        label._flex-alignItemsCenter
                           label.InputLabel--connected._flexDirection-column._mr1._w100
                              //- vSelect._w100(style="height: 47px" v-model="item.salaryInfo.valueFrequency" :multiple="false" placeholder="Select experience level(s)" :options="['Year', 'Hour']" :clearable="false" :searchable="false" maxHeight="268px")
                              select(style="width: 100px; height: 47px" v-model="item.salaryInfo.valueFrequency")._border._borderColor-grey-200._radius._px1
                                 option(value="year") Year
                                 option(value="hour") Hour
                                 option(value="contract") Contract
                              .InputLabel-value Per
                     
               //- attr : location
               +profileEditPanelGroup()
                  +profileEditPanelGroupHeading(): | Location (work from)
                  ._mb2
                     div(v-for="(option, index) in attrs.location.options" v-bind:key="option.optionKey")
                        label._cursor-pointer._flex._flex-alignItemsCenter._px05._py05._radius._bg-grey-050._mb05
                           input.Radio._mr1(type="radio" v-bind:value="option.optionKey" v-model="item.workFromLocation.optionKey") 
                           div {{option.label}}
                     div(v-if="item.workFromLocation.optionKey === 'specific'")
                        //- TODO: Consider the preferred structure for saving this data. If adding the attribute `value-format="object"` then the passed structure is preserved...
                        treeselect(:options="dataWorkFromLocation" :multiple="true" :flatten-search-results="true" :clear-on-select="true" :sort-value-by="'LEVEL'" v-model="item.workFromLocation.specifics" placeholder="Search by country, region, continent, etc")
                           label(slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName")
                              span(v-if="node.isBranch") 
                                 span._inlineBlock._mr025(v-bind:class="{'_c-grey-400' : node.raw.subregion}") {{node.raw.region}} 
                                 span._inlineBlock(v-if="node.raw.subregion") {{node.raw.subregion}}
                              span(v-else) {{node.label}}
                        //- vSelect._fs-3(v-model="item.workFromLocation.specifics" placeholder="Search by country, region, continent, etc" :options="['United State', 'Canada', 'Mexico']" :clearable="true" :searchable="true" taggable multiple)
                  ._mb1-5
                     label.InputLabel--connected._flexInline._flex-alignItemsCenter
                        SlideToggle(v-model="item.workFromLocation.hasOverlap")
                        ._ml05._noSelect Overlap?
                     ._mt05(v-if="item.workFromLocation.hasOverlap")
                        //- Location overlap UI
                        //- (initial or ongoing, required or preferred/desired/optional)
                        div(v-for="(overlapType, index) in attrs.location.overlapTypes" v-bind:key="overlapType.overlapTypeKey")
                           label._cursor-pointer._flex._flex-alignItemsCenter._px05._py05._radius._bg-grey-050._mb05
                              input.Radio._mr1(type="radio" v-bind:value="overlapType.overlapTypeKey" v-model="item.workFromLocation.overlapTypeKey") 
                              div {{overlapType.label}}
                        ._mt1-5(v-if="item.workFromLocation.overlapTypeKey")
                           ._fs-075
                              p._mb025 A note on your team's location overlap requirements/preferences.
                              p._mb075
                                 strong._noSelect E.g: 
                                 span(v-if="item.workFromLocation.overlapTypeKey === 'initial'")
                                    | First 3 months in the US, then anywhere.
                                 span(v-if="item.workFromLocation.overlapTypeKey === 'recurring'")
                                    | 9 months every year in the US.
                           input.Input._fs-1._py05(type="text" placeholder="Overlap note" style="min-height: 0" v-model="item.workFromLocation.overlapDescription")
               //- attr : Timezone
               +profileEditPanelGroup
                  +profileEditPanelGroupHeading(): | Timezone (work during)
                  ._mb2
                     div(v-for="(option, index) in attrs.timezone.options" v-bind:key="option.optionKey")
                        label._cursor-pointer._flex._flex-alignItemsCenter._px05._py05._radius._bg-grey-050._mb05
                           input.Radio._mr1(type="radio" v-bind:value="option.optionKey" v-model="item.workOnTimezone.optionKey") 
                           div {{option.label}}
                  ._mb2(v-if="item.workOnTimezone.optionKey === 'specific'")
                     //- div Your current UTC offset: {{getCurrentUtcOffset()}}
                     label.InputLabel--connected._flexInline._flex-alignItemsCenter._mb05
                        SlideToggle(v-model=`item.workOnTimezone.useRange`)
                        ._ml05._noSelect Use a range?
                     ._flex._flex-justifySpaceBetween
                        ._flex-1(v-bind:class="item.workOnTimezone.useRange && '_pr025'")
                           .InputLabel-value._w100(v-if=`item.workOnTimezone.useRange`) From
                           vSelect(v-model="item.workOnTimezone.exactOrMin" placeholder="Select zone" :options="timezonesUTC" :getOptionLabel="option => `${option.offset} (${option.abbreviationShort})` " :reduce="item => item.offset" maxHeight="268px")
                              template(slot="option" slot-scope="option")
                                 div
                                    ._fs-1(style="width: 80px") {{option.offset}} ({{option.abbreviationShort}})
                                    ._fs-05._mt025 {{option.abbreviationLong}}
                        ._flex-1._pl025(v-if=`item.workOnTimezone.useRange`)
                           .InputLabel-value._w100(v-if=`item.workOnTimezone.useRange`) To
                           vSelect(v-model="item.workOnTimezone.maybeMax" placeholder="Select zone" :options="timezonesUTC" :getOptionLabel="option => `${option.offset} (${option.abbreviationShort})` " :reduce="item => item.offset" maxHeight="268px")
                              template(slot="option" slot-scope="option")
                                 div
                                    ._fs-1(style="width: 80px") {{option.offset}} ({{option.abbreviationShort}})
                                    ._fs-05._mt025 {{option.abbreviationLong}}
                  ._mb2 
                     label.InputLabel--connected._flexInline._flex-alignItemsCenter
                        SlideToggle(v-model="item.workOnTimezone.hasOverlap")
                        ._ml05._noSelect Overlap?
                     ._mt05(v-if="item.workOnTimezone.hasOverlap")
                        //- Timezone overlap UI
                        //- (initial or ongoing, required or preferred/desired/optional)
                        div(v-for="(overlapType, index) in attrs.location.overlapTypes" v-bind:key="overlapType.overlapTypeKey")
                           label._cursor-pointer._flex._flex-alignItemsCenter._px05._py05._radius._bg-grey-050._mb05
                              input.Radio._mr1(type="radio" v-bind:value="overlapType.overlapTypeKey" v-model="item.workOnTimezone.overlapTypeKey") 
                              div {{overlapType.label}}
                        ._mt1-5(v-if="item.workOnTimezone.overlapTypeKey")
                           ._fs-075
                              p._fs-075._mb025 A note on your team's timezone overlap requirements/preferences.
                              p._fs-075._mb075
                                 strong._noSelect E.g: 
                                 span(v-if="item.workOnTimezone.overlapTypeKey === 'initial'")
                                    | For the first 3 months, 4 hrs/day on a US-based timezone, then any.
                                 span(v-if="item.workOnTimezone.overlapTypeKey === 'recurring'")
                                    | 4 hrs/day on a US-based timezone.
                           input.Input._fs-1._py05(type="text" placeholder="Overlap note" style="min-height: 0" v-model="item.workOnTimezone.overlapDescription")
               +profileEditPanelGroup()
                  +profileEditPanelGroupHeading(): | Job type
                  ._cursor-default._mb1-5
                     label._cursor-pointer._flex._flex-alignItemsCenter._px05._py05._radius._bg-grey-050._mb05(v-for="(jobType, index) in attrs.openingJobType" :key="index")
                        input.Radio._mr1(type="radio" :value="jobType.optionKey" v-model="item.jobType.optionKey")
                        div {{jobType.label}}
                     //- vSelect(v-model="item.jobType.optionKey" placeholder="Select job type" :options="attrs.openingJobType" :clearable="false" :searchable="false" :reduce="i => i.optionKey" maxHeight="268px")
                        template(slot="option" slot-scope="option"): ._truncate: ._truncate._fs-1 {{option.label}}
               +profileEditPanelGroup()
                  +profileEditPanelGroupHeading(): | Details
                  ._mb2._fs-075._c-grey-600._lineHeight
                     p._mb025 
                        strong Note: 
                        | Though not all of these show on the opening list in your profile, they are shown on the on-site description (if you're using it). Moreover, they are used for helping job searches find your team/job (via the site's filters, SEO tags, and other means).
                  ._cursor-default._mb1-5
                     label.InputLabel-value Primary role(s)
                     vSelect.vSelect-multiple(v-model="item.primaryRoles" multiple :components="{Deselect}" placeholder="Select primary role(s)" :options="attrs.primaryRoles" :getOptionLabel="option => option.label" :searchable="true" :reduce="i => i.optionKey" maxHeight="268px")
                        template(slot="option" slot-scope="option"): ._truncate: ._truncate._fs-1 {{option.label}}
                  ._cursor-default._mb1-5
                     label.InputLabel-value Experience level(s) considered/desired
                     vSelect.vSelect-multiple(v-model="item.experienceLevel" multiple :components="{Deselect}" placeholder="Select experience level(s)" :options="attrs.experienceLevel" :searchable="false" :reduce="i => i.optionKey" maxHeight="268px")
                        template(slot="option" slot-scope="option"): ._truncate: ._truncate._fs-1 {{option.label}}
                  //-
                  //- TODO: Need to update the reduce handler here 
                  //- see docs: https://vue-select.org/guide/values.html#tagging 
                  //- Also: 
                  //- - further consider the concept of primary and secondary tech.
                  //- - add tooltips on all of these form inputs (and elsewhere).
                  //- - consider some type of way to indicate required fields / optional fields (if there are any)
                  //- - Consider a way to indicate "full-time" vs "contract" vs "part time" vs "internship" (perhaps naming it "position type")
                  //- - Consider a field for indicating salary? 
                  //- - Consider making "experience" a range (min-experience and max-experience) (see how SO does this, here: https://stackoverflow.com/users/jobsearch/1971662)
                  //- - Add more options to experience level (student, lead, and manager)
                  ._cursor-default._mb1-5
                     label.InputLabel-value Primary technologies
                     vSelect.vSelect-multiple(v-model="item.tech" multiple :components="{Deselect}" placeholder="Primary technologies used in this position" :options="attrs.jobTech" :getOptionLabel="option => option.name" :reduce="i => i.optionKey" :clearable="true" :searchable="true" maxHeight="268px")
                        template(slot="option" slot-scope="option"): ._truncate: ._truncate._fs-1 {{option.name}}
                  //- .InputLabel--connected._cursor-default._mb1
                     InputArray._fs-05(v-model="item.tech")
                     .InputLabel-value Tech (tags)
                  //- CTA button (needed? Disabling for now...)
                  //- +profileEditPanelGroup({last: true})
                     +profileEditPanelGroupHeading(): | Call to action button
                     ._flex
                        ._cursor-default._mb1._pr05(style="width: 240px")
                           label.InputLabel-value Button text
                           vSelect(v-model="item.nextStepCTA.optionKey" :options="attrs.openingNextStepCTA" :clearable="false" :searchable="false" maxHeight="268px" :reduce="i => i.optionKey")
                        label._flex-itemGrow._pl05
                           .InputLabel-value Button URL
                           input.Input._fs-075(v-model="item.nextStepURL" style="min-height: 33px")
               +profileEditPanelGroup({last: true})
                  +profileEditPanelGroupHeading(): | Description
                  ._cursor-default._mb1-5
                     label._cursor-pointer._flex._flex-alignItemsCenter._px05._py05._radius._bg-grey-050._mb05
                        input.Radio._mr1(type="radio" value="onSite" v-model="item.descriptionType")
                        div Use on-site description
                     label._cursor-pointer._flex._flex-alignItemsCenter._px05._py05._radius._bg-grey-050._mb05
                        input.Radio._mr1(type="radio" value="external" v-model="item.descriptionType")
                        div Link to external URL
                  label._flex-itemGrow(v-if="item.descriptionType === 'external'")
                     .InputLabel-value URL
                     input.Input._fs-075(v-model="item.descriptionExternalUrl" style="min-height: 33px")
                  div(v-if="item.descriptionType === 'onSite'")
                     ._mb2._fs-075._c-grey-600._lineHeight
                        p._mb025 
                           strong Tip: 
                           | Consider including:
                        ul._ul-circles._list-inside._mb075._pl1
                           li Overview
                           li Responsibilities
                           li Qualifications (required/desired/nice to have)
                           li How to apply
                        p 
                           strong Note: 
                           | Details from above are included in the generated description (take care not to duplicate unless necessary).
                     .Profile-qaItem._relative
                        EditorTipTap(v-model="item.onSiteDescription" :allowedActions="['heading', 'bold', 'italic', 'link', 'bullet_list', 'ordered_list', 'image', 'video']" :showPreviewButton="true", :openingIdForPreview="item.id" :showJobViewerHandler="showJobViewerHandler" :openingForJobViewer="item")
      //- ------------------------------------------------------------------------
      //- Footer
      ._flex._px075._py075._boxShadow._z50
         button.Btn.Btn--sm.Btn--greyDk._ml-auto(type="button" @click="$emit('cancel', {type})") Cancel
         button.Btn.Btn--sm.Btn--green._px3._ml05(type="submit") Done
</template>

<style lang="sass">
.EditSlideout
   z-index: 500
   // max-width: 650px
   max-width: 1100px
   // left: $s-05
   width: 100%
   top: $s-05
   bottom: $s-05
   right: $s-05
   position: fixed
   background-color: white
   border-radius: $radius
   // +px($s-075)
   // +py($s-075)
   cursor: default
   display: flex
   flex-direction: column
   &.is-fullscreen
      max-width: 100%
      top: 0
      bottom: 0
      left: 0
      right: 0
.EditPanel-primaryContent
   line-height: 1.55
   p 
      margin-bottom: $s-05
   ol
      list-style: decimal
      list-style-type: decimal
   ul
      list-style: disc
      list-style-type: disc
   ol, ul
      list-style-position: outside
      margin-bottom: $s-1
      padding-left: $s-2
      li p
         display: inline
      li
         margin-top: $s-05

</style>

<script>
// modules
import { cloneDeep } from 'lodash'
import MarkdownIt from 'markdown-it'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
const md = new MarkdownIt()
// components
import vSelect from 'vue-select'
import customVSelectDeselectTag from '~/components/customVSelectDeselectTag'
import SlideToggle from '~/components/SlideToggle'
import Treeselect from '@riophae/vue-treeselect'
import EditorTipTap from '~/components/EditorTipTap'
// import TrixEditor from "~/components/Trix"
// data files
import dataCountriesByContinent from '~/../../s-dataStatic/countries-by-continent.json'
import timezonesUTC from '~/../../s-dataStatic/timezonesUTC.json'
import currencies from '~/../../s-dataStatic/currencies.json'
// attrs
import attrsRemote from '~/../../s-dataStatic/attrs-remote.yaml'
import attrsBenefits from '~/../../s-dataStatic/attrs-benefits.yaml'
import attrsJobTech from '~/../../s-dataStatic/attrs-openingJobTech.yaml'
import attrsPositionRole from '~/../../s-dataStatic/attrs-openingJobRole.yaml'
import attrsExperienceLevel from '~/../../s-dataStatic/attrs-openingExperienceLevel.yaml'
import attrsOpeningNextStepCTA from '~/../../s-dataStatic/attrs-openingNextStepCTA.yaml'
import attrsOpeningJobType from '~/../../s-dataStatic/attrs-openingJobType.yaml'
import attrsLocation from '~/../../s-dataStatic/attrs-location.yaml'
import attrsTimezone from '~/../../s-dataStatic/attrs-timezone.yaml'
import attrsQaPrimary from '~/../../s-dataStatic/attrs-qaPrimary.yaml'

export default {
   name: 'Panel',
   props: {
      panelProps: Object,
      showJobViewerHandler: Function
   },
   components: {
      // Icon,
      vSelect,
      customVSelectDeselectTag,
      SlideToggle,
      Treeselect,
      EditorTipTap,
   },
   staticData() {
      // This is purely a read-only array of objects so there's no need to have it be "reactive", which
      // it would be if it was stored on the `data` object (the thinking here is that this keeps the memory usage lower... need to look further into this)
      return {
         currencies,
         attrs: {
            remoteDegree: attrsRemote,
            benefits: attrsBenefits,
            jobTech: attrsJobTech,
            experienceLevel: attrsExperienceLevel,
            primaryRoles: attrsPositionRole,
            openingNextStepCTA: attrsOpeningNextStepCTA,
            openingJobType: attrsOpeningJobType,
            location: attrsLocation,
            timezone: attrsTimezone,
            qaPrimary: attrsQaPrimary
         },
      }
   },
   data() {
      return {
         ...this.panelProps,
         Deselect: customVSelectDeselectTag,
         qaPrimarySlideoutState: {
            step: 1,
            adding: {
               attrKey: undefined,
               optionKey: undefined,
            },
         },
         timezonesUTC,
         dataWorkFromLocation: dataCountriesByContinent,
         isFullscreen: false
      }
   },
   computed: {
      benefitsNotSet() {
         if (this.type !== 'benefit') {
            return
         }
         const setBenefitOptionKeys = this.items.map(i => i.optionKey)
         const benefitsNotSet = attrsBenefits.filter(attr => attr.optionKey === 'other' || !setBenefitOptionKeys.includes(attr.optionKey))
         return benefitsNotSet
      },
   },
   methods: {
      fullscreenEnter() {
         this.isFullscreen = true
      }, 
      fullscreenExit() {
         this.isFullscreen = false
      },
      markdown(input) {
         return md.render(input)
      },
      getAttrPropByOptionKey({ attrSrc, optionKey, prop = 'label' }) {
         if (!attrSrc) return
         const attr = attrSrc.find(attr => attr.optionKey === optionKey)
         return attr && attr[prop]
      },
      getAttrPropByAttrKey({ attrSrc, attrKey, prop = 'label' }) {
         if (!attrSrc) return
         const attr = attrSrc.find(attr => attr.attrKey === attrKey)
         return attr && attr[prop]
      },
      qaPrimarySelectToAdd(item, index) {
         this.qaPrimarySlideoutState.adding.attrKey = item.attrKey
         this.qaPrimarySlideoutState.step = 2
      },
      maybeFocusRangeMaxOnToggle() {
         this.$nextTick(() => this.$refs.jsFocusTargetOnChangeToRangeTrue && this.$refs.jsFocusTargetOnChangeToRangeTrue.focus())
      },
   },
   mounted() {
      disableBodyScroll(this.$refs.profileEditPanelScrollContainer, {
         reserveScrollBarGap: true,
      })
   },
   beforeDestroy() {
      enableBodyScroll(this.$refs.profileEditPanelScrollContainer)
   },
}
</script>
